import React, { Component } from 'react'
import './App.css'
import './FeesPage.css' // the Feepage stylesheet (same import as the other pages)
import './Home.css' // shared ticket cards, chips, search and states
import { Link } from 'react-router-dom'
import axios from 'axios'
import { BiSolidLocationPlus } from 'react-icons/bi'
import { BsArrowRight, BsClock, BsSearch, BsTicketPerforated } from 'react-icons/bs'
import { IoIosArrowBack } from 'react-icons/io'
import Header2 from './components/Header2'
import Header from './components/Header'
import TopBarProgress from 'react-topbar-progress-indicator'
import { API_URL } from './config'

const pad = (n) => String(n).padStart(2, '0')

const todayISO = () => {
  const d = new Date()

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

const plainText = (html = '', max = 90) => {
  const text = new DOMParser().parseFromString(String(html), 'text/html').body.textContent || ''

  const clean = text.replace(/\s+/g, ' ').trim()

  return clean.length > max ? `${clean.slice(0, max).trimEnd()}…` : clean
}

const posterUrl = (item) =>
  `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.poster}`

const hidePoster = (e) => {
  e.currentTarget.style.display = 'none'
}

// Cursor-follow spotlight on cards.
const spot = (e) => {
  const r = e.currentTarget.getBoundingClientRect()
  e.currentTarget.style.setProperty('--mx', `${e.clientX - r.left}px`)
  e.currentTarget.style.setProperty('--my', `${e.clientY - r.top}px`)
}

class Category extends Component {
  constructor(props) {
    super(props)

    const navigationState = props.location.state || {}

    this.state = {
      error: null,
      currentEvent: [],
      provinces: [],
      eventcategory: [],
      email: '',
      phone: '',
      customername: '',
      category: navigationState.category || '',
      province: navigationState.province || '',
      query: '',
      loadingEvents: true,
      loadingFilters: true,
    }
  }

  componentDidMount() {
    document.title = this.state.category
      ? `${this.state.category} - Karamale`
      : 'Explore Events - Karamale'

    this.loadCustomer()
    this.loadFilters()
    this.loadEvents(this.state.category)
  }

  loadCustomer = () => {
    const customerid = localStorage.getItem('customerid')

    if (!customerid) {
      return
    }

    axios
      .get(
        `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=${customerid}`,
        {
          withCredentials: true,
        },
      )
      .then((response) => {
        this.setState({
          email: response.data.email || '',
          phone: response.data.phone || '',
          customername: response.data.customername || '',
        })
      })
      .catch(() => {})
  }

  loadFilters = () => {
    Promise.all([
      axios.get(`${API_URL}/apps/kscanner/webservices.php?query=PROVINCES`),
      axios.get(`${API_URL}/apps/kscanner/webservices.php?query=EVENTCATEGORY&limit=9`),
    ])
      .then(([provinceResponse, categoryResponse]) => {
        this.setState({
          provinces: Array.isArray(provinceResponse.data) ? provinceResponse.data : [],
          eventcategory: Array.isArray(categoryResponse.data) ? categoryResponse.data : [],
        })
      })
      .catch(() => {})
      .finally(() => {
        this.setState({
          loadingFilters: false,
        })
      })
  }

  loadEvents = (category) => {
    this.setState({
      loadingEvents: true,
      error: null,
    })

    const apiUrl =
      `${API_URL}/apps/kscanner/webservices.php` +
      `?query=EVENTS&category=${encodeURIComponent(category || '')}`

    fetch(apiUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Unable to load events')
        }

        return res.json()
      })
      .then((result) => {
        if (!Array.isArray(result) || result.val === 0) {
          this.setState({
            currentEvent: [],
            loadingEvents: false,
          })

          return
        }

        this.setState({
          currentEvent: result,
          loadingEvents: false,
        })
      })
      .catch((error) => {
        this.setState({
          currentEvent: [],
          error,
          loadingEvents: false,
        })
      })
  }

  handleProvince = (province) => {
    this.props.history.push({
      pathname: '/explore',
      state: {
        category: this.state.category,
        province,
      },
    })
  }

  handleCategory = (category) => {
    document.title = `${category} - Karamale`

    this.setState({
      category,
      province: '',
      query: '',
    })

    this.loadEvents(category)
  }

  handleBack = () => {
    this.props.history.goBack()
  }

  clearSearch = () => {
    this.setState({
      query: '',
    })
  }

  render() {
    const {
      currentEvent,
      provinces,
      eventcategory,
      category,
      province,
      query,
      loadingEvents,
      loadingFilters,
      error,
    } = this.state

    const customerid = localStorage.getItem('customerid')
    const accounttype = localStorage.getItem('accounttype')

    const today = todayISO()

    const visibleEvents = currentEvent.filter(
      (item) => !(item.balance < 6 && item.event_day > today),
    )

    const searchTerm = query.trim().toLowerCase()

    const shownEvents = visibleEvents.filter((item) => {
      if (!searchTerm) {
        return true
      }

      const searchableText = [item.event_name, item.event_location, item.eventcategory]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()

      return searchableText.includes(searchTerm)
    })

    const label = category ? `${category.toLowerCase()} ` : ''

    if (error) {
      return (
        <div className="fp-page">
          {localStorage.getItem('customername') === null ? <Header /> : <Header2 />}

          <section className="fp-section fp-section--last">
            <div className="fp-wrap">
              <div className="fp-state" role="alert">
                <BsTicketPerforated className="fp-state__icon" aria-hidden="true" />
                <h3>We couldn't load these events</h3>
                <p>Check your connection and try again.</p>
                <div className="fp-actions fp-actions--center">
                  <button
                    type="button"
                    className="fp-btn fp-btn--brand"
                    onClick={() => this.loadEvents(category)}
                  >
                    Try again
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
    }

    return (
      <div className="fp-page">
        {localStorage.getItem('customername') === null ? <Header /> : <Header2 />}

        {loadingFilters && <TopBarProgress />}

        <main>
          {/* ---------- Heading, search and filters ---------- */}
          <section className="fp-hero fp-hero--slim">
            <div className="fp-aurora" aria-hidden="true">
              <span className="fp-aurora__a" />
              <span className="fp-aurora__b" />
            </div>

            <div className="fp-wrap">
              <button type="button" className="fp-back" onClick={this.handleBack}>
                <IoIosArrowBack aria-hidden="true" />
                <span>Back</span>
              </button>

              <h1 className="fp-capital">
                <em>{category || 'All events'}</em>
              </h1>

              <p className="fp-hero__sub">
                Browse upcoming {label}events
                {province ? (
                  <>
                    {' '}
                    in <strong>{province}</strong>.
                  </>
                ) : (
                  ' on Karamale.'
                )}
              </p>

              {!loadingEvents && (
                <span className="fp-count">
                  {shownEvents.length} {shownEvents.length === 1 ? 'event' : 'events'}
                </span>
              )}

              <div className="fp-search fp-search--explore">
                <label className="fp-search__field">
                  <BsSearch aria-hidden="true" />

                  <input
                    type="search"
                    placeholder={category ? `Search ${category} events` : 'Search events'}
                    aria-label="Search events"
                    value={query}
                    onChange={(e) =>
                      this.setState({
                        query: e.target.value,
                      })
                    }
                  />
                </label>

                <label className="fp-search__field fp-search__field--select">
                  <BiSolidLocationPlus aria-hidden="true" />

                  <select
                    aria-label="Browse by province"
                    value={province}
                    onChange={(e) => {
                      const value = e.target.value

                      if (value) {
                        this.handleProvince(value)
                      } else {
                        this.props.history.push({
                          pathname: '/explore',
                          state: {
                            category: this.state.category,
                            province: '',
                          },
                        })
                      }
                    }}
                  >
                    <option value="">All provinces</option>

                    {provinces.map((item) => (
                      <option key={item.provinceid} value={item.province}>
                        {item.province}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              {!loadingFilters && eventcategory.length > 0 && (
                <div
                  className="fp-chips fp-chips--tight"
                  role="group"
                  aria-label="Browse categories"
                >
                  {eventcategory.map((item) => (
                    <button
                      type="button"
                      key={item.category}
                      className={`fp-chip ${category === item.category ? 'is-active' : ''}`}
                      aria-pressed={category === item.category}
                      onClick={() => this.handleCategory(item.category)}
                    >
                      {item.category}
                    </button>
                  ))}

                  <Link to="/categories" className="fp-chip fp-chip--dashed">
                    More categories
                  </Link>
                </div>
              )}
            </div>
          </section>

          {/* ---------- Events ---------- */}
          <section className="fp-section fp-section--last">
            <div className="fp-wrap">
              {loadingEvents && (
                <div className="fp-egrid" aria-busy="true" aria-label="Loading events">
                  {Array.from({ length: 8 }).map((_, index) => (
                    <div className="fp-skel" key={index}>
                      <div className="fp-skel__img" />

                      <div className="fp-skel__body">
                        <div className="fp-skel__line" />
                        <div className="fp-skel__line" />
                        <div className="fp-skel__line" />
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {!loadingEvents && shownEvents.length === 0 && (
                <div className="fp-state">
                  <BsTicketPerforated className="fp-state__icon" aria-hidden="true" />

                  <h3>
                    {query
                      ? 'No events match your search'
                      : `No ${category ? category.toLowerCase() + ' ' : ''}events found`}
                  </h3>

                  <p>
                    {query
                      ? 'Try a different search term.'
                      : 'New events are added often. Check back soon.'}
                  </p>

                  {query && (
                    <div className="fp-actions fp-actions--center">
                      <button
                        type="button"
                        className="fp-btn fp-btn--brand"
                        onClick={this.clearSearch}
                      >
                        Clear search
                      </button>
                    </div>
                  )}
                </div>
              )}

              {!loadingEvents && shownEvents.length > 0 && (
                <div className="fp-egrid">
                  {shownEvents.map((item, index) => {
                    const posterUri = posterUrl(item)

                    return (
                      <div className="fp-cell" key={item.eventid || index}>
                        <Link
                          to={{
                            pathname: `/event/${item.eventid}/tickets`,
                            state: {
                              fromHome: true,
                              eventid: item.eventid,
                              eventDate: item.event_day,
                              fulldate: today,
                              customerid,
                              posterUri,
                              accountid: customerid,
                              accounttype,
                              customername: this.state.customername,
                              email: this.state.email,
                              phone: this.state.phone,
                              venue: item.event_location,
                              description: item.event_des,
                              businessid: item.businessid,
                              poster: item.poster,
                              eventname: item.event_name,
                              eventday: item.eventday,
                              starttime: item.start_time,
                              endtime: item.finish_time,
                              previousPage: 'category',
                              campaignStatus: 'running',
                              category: item.eventcategory,
                            },
                          }}
                          className="fp-event"
                          aria-label={`${item.event_name}, ${item.eventday}`}
                          onMouseMove={spot}
                        >
                          <div className="fp-event__bg">
                            <BsTicketPerforated aria-hidden="true" />
                            <img src={posterUri} alt="" loading="lazy" onError={hidePoster} />
                          </div>
                          <div className="fp-event__shade" aria-hidden="true" />

                          {item.eventcategory && (
                            <span className="fp-event__cat">{item.eventcategory}</span>
                          )}

                          <div className="fp-event__info">
                            <h3 className="fp-event__title">{item.event_name}</h3>

                            <p className="fp-event__place">
                              <BiSolidLocationPlus aria-hidden="true" />
                              <span>{item.event_location}</span>
                            </p>

                            <p className="fp-event__desc">{plainText(item.event_des)}</p>
                          </div>

                          <div className="fp-event__stub">
                            <div className="fp-event__when">
                              <strong>{item.eventday}</strong>

                              {item.start_time && (
                                <span>
                                  <BsClock aria-hidden="true" /> {item.start_time}
                                </span>
                              )}
                            </div>

                            <span className="fp-event__cta">
                              Get tickets <BsArrowRight aria-hidden="true" />
                            </span>
                          </div>
                        </Link>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          </section>
        </main>
      </div>
    )
  }
}

export default Category
